import { type DragEvent } from 'react';

import { type Clip } from '@air/api/types';

import { type CanvasAssetGrabAnchor } from '~/components/Shared/Drag/setCanvasAssetDragData';

/** Normalized grab point within the dragged clip, for the canvas drop target (CANVAS_ASSET_GRAB_OFFSET_TYPE). */
export const getCanvasAssetGrabAnchor = (event: DragEvent<HTMLElement>, clip: Clip): CanvasAssetGrabAnchor => {
  const thumbnailEl = event.currentTarget.querySelector<HTMLElement>('img, video') ?? event.currentTarget;
  const rect = thumbnailEl.getBoundingClientRect();
  const anchorX = rect.width > 0 ? Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width)) : 0;

  // The gallery card img is object-cover center-cropped to fit the thumbnail display area (which
  // is shorter than the clip's natural height when a title footer is visible), so we offset by
  // the center-crop amount before normalizing.
  const { width: clipW, height: clipH } = clip;
  const aspectRatio = clipW && clipH ? clipW / clipH : null;
  const naturalHeight = aspectRatio !== null && rect.width > 0 ? rect.width / aspectRatio : rect.height;
  const cropTop = Math.max(0, (naturalHeight - rect.height) / 2);
  const anchorY =
    naturalHeight > 0 ? Math.min(1, Math.max(0, (cropTop + (event.clientY - rect.top)) / naturalHeight)) : 0;

  return { x: anchorX, y: anchorY };
};
